import { Tooltip } from '@/components/primitives/Tooltip'
import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { useCallback, useMemo, useState } from 'react'
import { form } from './formState'
import { useTexts } from './hooks/useTexts'

const fullWidthStyle = { width: '100%' }

export function ReasonsForNotCompletedOrdersMenu() {
  const texts = useTexts()
  const {
    field: { value },
  } = form.useFormField('reasonsForNotCompletedOrders')

  const fieldApi = form.useFormFieldApi('reasonsForNotCompletedOrders')

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  const isASCSorted = useMemo(() => {
    const base = JSON.stringify(value)
    const sorted = JSON.stringify([...value].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)))

    return base === sorted
  }, [value])

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = useCallback(event => {
    setAnchorEl(event.currentTarget)
  }, [])
  const handleClose = useCallback(() => {
    setAnchorEl(() => null)
  }, [])

  const handleSort = useCallback(() => {
    const updated = [...value]
    if (isASCSorted) {
      updated.sort((a, b) => (a > b ? -1 : a < b ? 1 : 0)) // DESC sort
    } else {
      updated.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)) // ASC sort
    }
    fieldApi.change(updated)
    handleClose()
  }, [value, fieldApi, handleClose, isASCSorted])

  const handleRemoveAll = useCallback(() => {
    fieldApi.change([])
    handleClose()
  }, [fieldApi, handleClose])

  return (
    <>
      <Tooltip title={texts.more} placement="top">
        <IconButton onClick={handleClick} data-testid="reason-for-orders_menu-btn">
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Tooltip title={texts.noReasons} placement="top" disabled={!!value.length}>
          <MenuItem
            sx={fullWidthStyle}
            onClick={handleSort}
            disabled={formDisabled || !value.length}
            data-testid="reason-for-orders_sort-btn"
          >
            {isASCSorted ? texts.desc : texts.asc}
          </MenuItem>
        </Tooltip>
        <Tooltip title={texts.noReasons} placement="top" disabled={!!value.length}>
          <MenuItem
            sx={fullWidthStyle}
            onClick={handleRemoveAll}
            disabled={formDisabled || !value.length}
            data-testid="reason-for-orders_remove-all-btn"
          >
            <Typography color="red">{texts.removeAll}</Typography>
          </MenuItem>
        </Tooltip>
      </Menu>
    </>
  )
}
